var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":"https://recruitcrm.io/jobs/campuskraft_jobs"}})])}
var staticRenderFns = []

export { render, staticRenderFns }